<template>
  <button
    :class="['px-4 py-1 border rounded text-sm', {
      'text-secondary-800 bg-secondary-100 hover:bg-secondary-200 border-secondary-600': !$attrs.disabled,
      'text-grey-300 bg-grey-100 border-grey-500': $attrs.disabled,
    }]"
    @click="showModal = true"
  >
    Manage Project Monitors
    <portal to="modals">
      <app-modal
        v-if="showModal"
        container-class="w-screen max-w-6xl"
        @close="showModal = false"
      >
        <app-card class="mx-6">
          <header class="px-6 py-4 bg-grey-100 border-b flex">
            <icon
              icon="add-circle"
              class="icons-primary w-8 h-8 mr-2"
            />
            <h1 class="text-xl flex-1">
              Manage Project Monitors
            </h1>
            <button
              class="text-grey-600 hover:text-red-800 transtion"
              type="button"
              @click="showModal = false"
            >
              <icon
                icon="close"
                class="w-6 h-6"
              />
            </button>
          </header>
          <div class="overflow-x-hidden">
            <div class="overflow-x-scroll relative">
              <table class="text-sm">
                <thead>
                  <tr>
                    <th
                      class="text-left px-6 py-4 bg-grey-100 border-b whitespace-no-wrap sticky pin-l border-r"
                    >
                      Name
                    </th>
                    <th
                      class="text-left px-6 py-4 bg-grey-100 border-b whitespace-no-wrap border-r"
                    >
                      Email
                    </th>
                    <th
                      v-for="project in localProjects"
                      :key="project.uuid"
                      class="text-left px-6 py-4 bg-grey-100 border-b whitespace-no-wrap border-r"
                    >
                      {{ project.ref }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="monitor in localMonitors"
                    :key="monitor.id"
                  >
                    <td
                      class="px-6 py-4 border-b whitespace-no-wrap sticky pin-l bg-white border-r"
                    >
                      {{ monitor.name }}
                      <small
                        v-if="!monitor.email_verified_at"
                        class="text-xs text-neutral-600 italic block"
                      >
                        Invitation Pending
                      </small>
                    </td>
                    <td
                      class="px-6 py-4 border-b whitespace-no-wrap border-r"
                    >
                      {{ monitor.email }}
                    </td>
                    <td
                      v-for="project in projects"
                      :key="project.uuid"
                      class="px-4 py-2 border-b whitespace-no-wrap border-r"
                      :class="currrentRoleForProject(monitor, project) ? 'bg-positive-100' : 'bg-negative-100'"
                    >
                      <select
                        :value="currrentRoleForProject(monitor, project)"
                        class="w-full border rounded px-2 py-1 pr-6"
                        :disabled:="inflight.includes(`${monitor.id}-${project.id}`)"
                        @change="manageMontiorProjectAccess(monitor, project, $event)"
                      >
                        <option :value="null">
                          No Access
                        </option>
                        <option
                          v-for="role in roles"
                          :key="role.value"
                          :value="role.value"
                        >
                          {{ role.label }}
                        </option>
                      </select>
                    </td>
                  </tr>
                </tbody>
                <tfoot class="bg-grey-100">
                  <tr>
                    <td
                      class="px-4 py-2 border-b whitespace-no-wrap sticky pin-l bg-grey-100 border-r"
                      :class="{
                        'bg-negative-500': errors.name && errors.name[0],
                      }"
                    >
                      <input
                        v-model.trim="form.name"
                        type="text"
                        placeholder="Monitor Name"
                        class="border rounded px-2 py-1 w-48 bg-white"
                      />
                    </td>
                    <td
                      class="px-4 py-2 border-b whitespace-no-wrap border-r"
                    >
                      <input
                        v-model.trim="form.email"
                        type="email"
                        placeholder="Monitor Email"
                        class="w-48 border rounded px-2 py-1"
                        :class="{
                          'bg-negative-500': errors.email && errors.email[0],
                        }"
                      />
                    </td>
                    <td
                      v-for="project in projects"
                      :key="project.uuid"
                      class="px-4 py-2 border-b whitespace-no-wrap border-r"
                      :class="form.projects[project.id] ? 'bg-positive-50' : 'bg-negative-50'"
                    >
                      <select
                        v-model="form.projects[project.id]"
                        class="w-full border rounded px-2 py-1 pr-6"
                      >
                        <option :value="null">
                          No Access
                        </option>
                        <option
                          v-for="role in roles"
                          :key="role.value"
                          :value="role.value"
                        >
                          {{ role.label }}
                        </option>
                      </select>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <footer class="px-4 py-2 bg-grey-100 border-t flex justify-end">
            <div class="w-32 mr-4">
              <app-button
                class="border-2"
                colour="delete"
                @click="showModal = false"
              >
                Cancel
              </app-button>
            </div>
            <div class="w-48">
              <app-button
                :disabled="!form.name || !form.email || !Object.values(form.projects).some(v => v)"
                @click="inviteMonitorToProjects"
              >
                Invite
              </app-button>
            </div>
          </footer>
        </app-card>
      </app-modal>
    </portal>
  </button>
</template>

<script>
export default {
  name: "FundingProjectFilter",
  props: {
    monitors: {
      type: Array,
      required: true
    },
    projects: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      inflight: [],
      showModal: false,
      localProjects: [],
      localMonitors: [],
      form: {
        name: "",
        email: "",
        projects: {}
      },
      errors: {}
    };
  },
  computed: {
    roles() {
      return [
        { value: "mentor", label: "Mentor" },
        { value: "msp", label: "MSP" },
        { value: "pdl", label: "PDL" }
      ];
    }
  },
  created() {
    this.$set(this, "localProjects", this.projects);
    this.$set(this, "localMonitors", this.monitors);
    this.$set(
      this.form,
      "projects",
      this.projects.reduce((acc, project) => {
        acc[project.id] = null;
        return acc;
      }, {})
    );
  },
  methods: {
    projectMonitorEntry(monitor, project) {
      return project.monitors.find(m => m.user_id === monitor.id);
    },
    isMonitorAssignedToProject(monitor, project) {
      return this.projectMonitorEntry(monitor, project) !== undefined;
    },
    validateRole(role) {
      return this.roles.some(r => r.value === role);
    },
    currrentRoleForProject(monitor, project) {
      const entry = this.projectMonitorEntry(monitor, project);
      return entry ? entry.role : null;
    },
    manageMontiorProjectAccess(monitor, project, event) {
      const entry = this.projectMonitorEntry(monitor, project);
      const og_role = entry?.role;
      const role = event.target.value;

      // If there is no entry, just process the role change
      if(!entry) {
        this.updateMonitorsEntry(monitor, project, role);
        return;
      }

      if(role != og_role && !confirm(`Are you sure you want to change ${monitor.name}'s role for project ${project.ref} from ${og_role || 'No Access'} to ${role || 'No Access'}?`)) {
        return entry.role = og_role;
      }

      // Handle No Access - remove the entry
      if (role === "" || role === null) {
        this.removeMonitorFromProject(monitor, project);
        return;
      }

      // Validate role
      if (!this.validateRole(role)) {
        return;
      }

      this.updateMonitorsEntry(monitor, project, role);
      return;
    },
    generateInflightKey(monitor, project) {
      return `${monitor.id}-${project.id}`;
    },
    removeInflightKey(inflightKey) {
      this.$set(this, "inflight", this.inflight.filter(k => k !== inflightKey))
    },
    updateMonitorsEntry(monitor, project, role) {
      const inflightKey = this.generateInflightKey(monitor, project);
      const entry = this.projectMonitorEntry(monitor, project);
      const og_role = entry?.role;

      axios
        .put(
          route("funding.projects.monitors.update", [
            this.$page.funding_pot.id,
            project.uuid
          ]),
          {
            user_id: monitor.id,
            role
          }
        )
        .then((res) => {
          if(entry) {
            entry.role = res.data.entry.role;
            return
          }

          project.monitors.push(res.data.entry);
        })
        .catch(() => {
          if(entry) entry.role = og_role;
          alert("Failed to update monitor role, reverting to previous role of " + og_role);
        })
        .finally(() => {
          this.removeInflightKey(inflightKey);
        });
    },
    removeMonitorFromProject(monitor, project) {
      const inflightKey = this.generateInflightKey(monitor, project);
      const entry = this.projectMonitorEntry(monitor, project);
      if(!entry) return;
      const og_role = entry?.role;

      axios
        .delete(
          route("funding.projects.monitors.delete", [
            this.$page.funding_pot.id,
            project.uuid
          ]),
          {
            data: {
              user_id: monitor.id
            }
          }
        )
        .then(() => {
          project.monitors = project.monitors.filter( m => m.user_id !== monitor.id);
        })
        .catch(() => {
          if(entry) entry.role = og_role;
          alert("Failed to remove monitor from project, reverting to previous role of " + og_role);
        })
        .finally(() => {
          this.removeInflightKey(inflightKey);
        });
    },
    inviteMonitorToProjects() {
      const projects = [];
      for (const [projectId, role] of Object.entries(this.form.projects)) {
        if (role) {
          projects.push({ competition_project_id: projectId, role });
        }
      }

      axios
        .post(
          route("funding.projects.monitors.store", [ this.$page.funding_pot.id ]),
          {
            name: this.form.name,
            email: this.form.email,
            projects
          }
        )
        .then(({data}) => {
          const { monitors, projects } = data;
          this.$set(this, "localMonitors", monitors);
          for (const project of this.localProjects) {
            const updatedProject = projects.find(p => p.id === project.id);
            if (updatedProject) {
              this.$set(project, "monitors", updatedProject.monitors);
            }
          }

          // Reset the form
          this.form.name = "";
          this.form.email = "";
          this.form.projects = projects.reduce((acc, project) => {
            acc[project.id] = null;
            return acc;
          }, {});
          this.errors = {};
        })
        .catch((err) => {
          if (err.response && err.response.status === 422) {
            this.errors = err.response.data.errors;
          } else {
            alert("Failed to invite monitor. Please try again.");
          }
        });
    }
  }
};
</script>
